import {getSellerInfo} from '@/api/seller'

const state = {
};

const mutations = {
};

const actions = {
  getsellerinfo({commit}, data) {
    return new Promise((resolve, reject) => {
      getSellerInfo(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
